import { RouteObject } from 'react-router-dom';

import { HomePage } from 'app/railways/pages/home';
import {
  AddEmployeePage,
  AllEmployeePage,
  DetailsEmployeePage,
} from 'app/terminals/domains/employees/pages';

import {
  AddProfilePage,
  AllProfilesPage,
  DetailsProfilePage,
} from '../domains/profiles/pages';
import { AddTerminalPage } from '../domains/terminals/pages/add-terminal.page';
import { AllTerminalsPage } from '../domains/terminals/pages/all-terminals.page';
import { DetailsTerminalPage } from '../domains/terminals/pages/details-terminal.page';
import { BaseLayout } from '../pages/layouts/base';
import { appRoute } from './routes';

export const router: RouteObject[] = [
  {
    index: true,
    element: (
      <BaseLayout header="Главная страница">
        <HomePage />
      </BaseLayout>
    ),
  },

  // Сотрудники
  {
    path: appRoute.EMPLOYEES.path,
    element: (
      <BaseLayout header="Все сотрудники">
        <AllEmployeePage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.EMPLOYEES.ADD.path,
    element: (
      <BaseLayout header="Добавление сотрудника">
        <AddEmployeePage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.EMPLOYEE.path,
    element: (
      <BaseLayout header="Информация о сотруднике">
        <DetailsEmployeePage />
      </BaseLayout>
    ),
  },

  // Профили терминалов
  {
    path: appRoute.PROFILES.path,
    element: (
      <BaseLayout header="Все профили терминалов">
        <AllProfilesPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.PROFILES.ADD.path,
    element: (
      <BaseLayout header="Добавление профиля терминала">
        <AddProfilePage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.PROFILE.path,
    element: (
      <BaseLayout header="Профиль терминала">
        <DetailsProfilePage />
      </BaseLayout>
    ),
  },

  // Терминалы
  {
    path: appRoute.TERMINALS.path,
    element: (
      <BaseLayout header="Все терминалы">
        <AllTerminalsPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.TERMINALS.ADD.path,
    element: (
      <BaseLayout header="Добавление терминала">
        <AddTerminalPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.TERMINAL.path,
    element: (
      <BaseLayout header="Данные терминала">
        <DetailsTerminalPage />
      </BaseLayout>
    ),
  },
];
